import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-school-base",
  "use": "icon-school-base-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-school-base\"><path d=\"M65.79532 539.2l422.94 292.47a41.07 41.07 0 0 0 46.73 0l423.05-292.59a41.07 41.07 0 0 0 6.47-62l-1-1a41.08 41.08 0 0 0-52.7-5.89L512.14532 737.66 111.92532 471.22a41.085 41.085 0 0 0-46.13 68z\" fill=\"#000000\" p-id=\"17306\" /><path d=\"M964.00532 661.12a41.07 41.07 0 0 0-52.69-5.89L512.14532 922.76 111.93532 656.27a41.08 41.08 0 0 0-52.5 5.85 41.07 41.07 0 0 0 6.37 62.13l423 292.43a41.09 41.09 0 0 0 46.73 0l423-292.55a41.08 41.08 0 0 0 6.46-62z\" fill=\"#000000\" p-id=\"17307\" /><path d=\"M471.92532 639a51.24 51.24 0 0 0 72.22 0l413-275.91a51.22 51.22 0 0 0 0-72.24l-413-275.95a51.22 51.22 0 0 0-72.24 0L67.14532 290.81a51.24 51.24 0 0 0 0 72.24z\" fill=\"#000000\" p-id=\"17308\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/school-base.svg
// module id = awKJ
// module chunks = 27